import MailIcon from "@src/app/assets/icons/mail.svg?react";
import RedantAvatarIcon from "@src/app/assets/icons/redant-avatar.svg?react";
import TwitterIcon from "@src/app/assets/icons/twitter.svg?react";
import type { ReactElement } from "react";

type Props = Readonly<{
  id?: string;
  imgSrc?: string;
  authorName?: string;
  email?: string;
  twitter?: string;
  designation?: string;
  description?: string;
}>;

export default function AuthorCard({
  id,
  imgSrc,
  authorName,
  email,
  twitter,
  designation,
  description,
}: Props): ReactElement {
  return (
    <div
      id={`author-card-${id}`}
      data-testid="author-card"
      className="grid grid-cols-1 lg:grid-cols-2"
    >
      <div className="flex h-fit flex-col flex-wrap gap-3 px-3 py-4 lg:flex-row lg:items-center lg:gap-4">
        <div className="flex flex-col gap-y-[12px]">
          {/* author name */}
          <div className="flex items-center gap-x-3">
            {imgSrc ? (
              <img
                src={imgSrc}
                alt={authorName}
                className="size-[60px] rounded-full bg-tertiary"
              />
            ) : (
              <RedantAvatarIcon width="60px" height="60px" />
            )}
            <div className="lg:py-[10px]">
              <h1 className="text-header-1 font-medium text-primary">
                {authorName}
              </h1>
            </div>
          </div>

          {/* email */}
          {email && (
            <div className="flex items-center">
              <MailIcon className="mx-2 -ml-0 text-icon-secondary" />
              <span className="text-body-2 font-medium text-secondary">
                {email}
              </span>
            </div>
          )}

          {/* twitter */}
          {twitter && (
            <div className="flex items-center">
              <TwitterIcon className="mx-2 -ml-0 text-icon-secondary" />
              <span className="text-body-2 font-medium text-secondary">
                {twitter}
              </span>
            </div>
          )}
        </div>
      </div>
      {(designation || description) && (
        <div className="flex flex-col px-3 py-4 max-lg:gap-y-[12px]">
          {designation && (
            <h2 className="text-header-2 font-medium text-secondary lg:my-[11px]">
              {designation}
            </h2>
          )}
          {description && (
            <p
              className="text-body-1 font-normal text-secondary lg:my-[12px]"
              dangerouslySetInnerHTML={{ __html: description || "" }}
            />
          )}
        </div>
      )}
    </div>
  );
}
